// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"23674":"1c4460f4071eff0e34e9","81421":"b2f7f34f06df2326963a"}[chunkId] + ".css";
};